import { render, staticRenderFns } from "./datashareRegister.vue?vue&type=template&id=e89a9b90"
import script from "./datashareRegister.vue?vue&type=script&lang=js"
export * from "./datashareRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports